var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isTermsData())?_c('div',[_c('div',{staticClass:"inquiry-list-wrapper"},[_c('div',{staticClass:"inquiry-content"},[_c('span',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.replaceBr(_vm.termsData.c_config))}})])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }